const DocumentInfoIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.172 3.172C3 4.343 3 6.229 3 10V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H13C16.771 22 18.657 22 19.828 20.828C20.999 19.656 21 17.771 21 14V10C21 6.229 21 4.343 19.828 3.172C18.656 2.001 16.771 2 13 2H11C7.229 2 5.343 2 4.172 3.172ZM7.25 8C7.25 7.80109 7.32902 7.61032 7.46967 7.46967C7.61032 7.32902 7.80109 7.25 8 7.25H16C16.1989 7.25 16.3897 7.32902 16.5303 7.46967C16.671 7.61032 16.75 7.80109 16.75 8C16.75 8.19891 16.671 8.38968 16.5303 8.53033C16.3897 8.67098 16.1989 8.75 16 8.75H8C7.80109 8.75 7.61032 8.67098 7.46967 8.53033C7.32902 8.38968 7.25 8.19891 7.25 8ZM7.25 12C7.25 11.8011 7.32902 11.6103 7.46967 11.4697C7.61032 11.329 7.80109 11.25 8 11.25H16C16.1989 11.25 16.3897 11.329 16.5303 11.4697C16.671 11.6103 16.75 11.8011 16.75 12C16.75 12.1989 16.671 12.3897 16.5303 12.5303C16.3897 12.671 16.1989 12.75 16 12.75H8C7.80109 12.75 7.61032 12.671 7.46967 12.5303C7.32902 12.3897 7.25 12.1989 7.25 12ZM8 15.25C7.80109 15.25 7.61032 15.329 7.46967 15.4697C7.32902 15.6103 7.25 15.8011 7.25 16C7.25 16.1989 7.32902 16.3897 7.46967 16.5303C7.61032 16.671 7.80109 16.75 8 16.75H13C13.1989 16.75 13.3897 16.671 13.5303 16.5303C13.671 16.3897 13.75 16.1989 13.75 16C13.75 15.8011 13.671 15.6103 13.5303 15.4697C13.3897 15.329 13.1989 15.25 13 15.25H8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DocumentInfoIcon; 